// VARIABLE DE ENTORNO
// export const AMBIENTE = 'DESARROLLO';
export const AMBIENTE = 'PRODUCCIÓN';

// DESA
// export const CONFIGURACION = {
//    // SERVER_URL: 'http://localhost:1012',
//    SERVER_URL: 'http://pre-ws.bago.com.ec:1012',
//    // SERVER_URL: 'http://200.32.69.226:3000',
//    // SERVER_URL: 'http://ws.bago.com.ec:1012',
//    //SERVER_URL_TS: 'http://localhost:3001',
//     SERVER_URL_TS: 'http://10.93.1.105:3001',
//    // SERVER_URL_TS: 'http://200.32.69.226:3001',
//    // SERVER_URL_TS_V2: 'http://localhost:3003',
//    SERVER_URL_TS_V2: 'http://10.93.1.105:3003',
//    // SERVER_URL_TS_V2: 'http://200.32.69.226:3003',
//    // SERVER_URL_TS_V2: 'http://ws.bago.com.ec:3003',
//    URL_FRONT_GESTION_CALIDAD: 'http://pre-ws.bago.com.ec:3007',
//    // URL_FRONT_ZONALES: 'http://localhost:4200/#/',
//    URL_FRONT_ZONALES: 'http://zonales.bagotest.com.ec:3010/#',
//    GCP_BUCKET_NAME: 'rega_test',
//    // SERVER_URL_TS: 'http://200.32.69.226:3001',
//    GOOGLE_CLOUD_STORAGE_PUBLIC_URI: 'https://storage.googleapis.com',
//    URL_FRONT_ZONALES_CONTINGENTE: 'http://10.94.0.190:3010/#',
//    URL_FRONT_PRESUPUESTOS: 'http://localhost:4200/#',
// };

// PROD
export const CONFIGURACION = {
   SERVER_URL: 'https://apisib.bago.com.ec:4012',
   SERVER_URL_TS: 'https://apisib.bago.com.ec:4001',
   SERVER_URL_TS_V2: 'https://apisib.bago.com.ec:4003',
   URL_FRONT_GESTION_CALIDAD: 'https://ws.bago.com.ec:4007',
   URL_FRONT_GESTION_CALIDAD_V2: 'https://app-sicab.bago.com.ec/#',
   GOOGLE_CLOUD_STORAGE_PUBLIC_URI: 'https://storage.googleapis.com',
   URL_FRONT_ZONALES: 'https://zonales.bago.com.ec:443/#',
   URL_FRONT_ZONALES_CONTINGENTE: 'http://ws.bago.com.ec:3011/#',
   GCP_BUCKET_NAME: 'sib_fichakam',
   URL_FRONT_PRESUPUESTOS: 'https://budget.bago.com.ec/#',
   URL_FRONT_DESCUENTOS: 'https://descuentos.bago.com.ec/#',
   URL_FRONT_CONGRESOS: 'https://congresos.bago.com.ec/#',
   URL_FRONT_MM_360: 'https://app-mm360.bago.com.ec/#',
   URL_FRONT_MEDGO_MIGRACION: 'https://app-congresos.bago.com.ec/#',
   URL_FRONT_CARGA_DATOS_OPERADOR: 'https://portal-ventas.bago.com.ec/#',
};

// PROD - NOTIFICACIONES FIREBASE
export const CONFIGURACIONES_FIREBASE = {
   senderID: 12038876851,
   keySend: 'key=AIzaSyBjng4NPhBEoM_bZmAesbpqqeQzqXWDcBk',
   apiweb: 'AIzaSyB1it6deTl2zAmGXpk_spkgARAaYJ2dUO0',
   authDomain: 'formatos-inversion.firebaseapp.com',
   databaseURL: 'https://formatos-inversion.firebaseio.com',
   projectId: 'formatos-inversion',
};

// Google cloud
export const CREDENCIALES_GOOGLE_CLOUD = {
   urlGoogleCloudStorage: 'https://storage.googleapis.com',
   portGoogleCloudStorage: '/sib_fichakam/sib_fichakam/'
};

// RUC FICHA KAM
export const RUC_CLIENTES_FICHA_KAM = {
   difare: '0990858322001',
   gpf: '1792238927001',
};
